import { useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, Stripe, StripeElementsOptions } from '@stripe/stripe-js';
import { BuyBackgroundCheckPage } from './BuyBackgroundCheckPage';
import { useDependencies } from '../../dependencies';

const OPTIONS: StripeElementsOptions = {
  mode: 'payment',
  amount: 1099,
  currency: 'usd',
  appearance: { theme: 'stripe' },
  setup_future_usage: 'off_session',
};

export const BuyBackgroundCheck = (): JSX.Element => {
  const { services } = useDependencies();
  const { config } = services;

  // Memoize the Stripe promise so we only load the Stripe.js script once,
  // not on every parent re-render.
  const stripePromise = useMemo<Promise<Stripe | null> | null>(
    () => (config.STRIPE_KEY ? loadStripe(config.STRIPE_KEY) : null),
    [config.STRIPE_KEY],
  );

  if (!config.STRIPE_KEY) {
    console.error('[BuyBackgroundCheck] Stripe key not configured.');
    return (
      <div className='container py-12 text-center'>
        <div className='us-card rounded p-6 max-w-md mx-auto'>
          <h2 className='text-lg font-semibold mb-2'>Payment unavailable</h2>
          <p className='text-sm text-neutral-600'>
            Please try again later or contact support.
          </p>
        </div>
      </div>
    );
  }

  return (
    <Elements stripe={stripePromise} options={OPTIONS}>
      <BuyBackgroundCheckPage />
    </Elements>
  );
};

export default BuyBackgroundCheck;
